<script>
export default {
  name: 'CountdownBlock',
  props: {
    loading: {
      type: Boolean,
    },
    timer: {
      type: Object,
    },
    header: {
      type: String,
    },
  },
};
</script>

<template>
  <div class="upcoming-card main-block text-center">
    <div class="countdown__title">{{ header }}:</div>
    <v-row class="countdown__counter">
      <v-col cols="3">
        <div class="countdown__digit">{{ timer.d }}</div>
        <div class="countdown__subline">days</div>
      </v-col>
      <v-col cols="3">
        <div class="countdown__digit">{{ timer.h }}</div>
        <div class="countdown__subline">hours</div>
      </v-col>
      <v-col cols="3">
        <div class="countdown__digit">{{ timer.m }}</div>
        <div class="countdown__subline">minutes</div>
      </v-col>
      <v-col cols="3">
        <div class="countdown__digit">{{ timer.s }}</div>
        <div class="countdown__subline">seconds</div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
.countdown {
  font-size: 2.2rem;
  font-weight: 600;

  &__title {
    margin-bottom: 0.4rem;
  }

  &__digit {
    font-size: 4.8rem;
  }

  &__subline {
    font-size: 1rem;
  }

  &__counter > div {
    position: relative;

    &:not(:last-child)::after {
      position: absolute;
      content: ':';
      right: -0.5rem;
      top: 1.1rem;
      font-size: 4.8rem;
    }
  }
}
</style>
